const STORAGE_KEY = "telos_marketing_v1"
const CAMPAIGN_KEYS = ["source", "medium", "campaign", "content"]
let catalog = { offers: [], ctas: {}, campaigns: [] }
let context = {}

export function approvedCampaign(value, campaigns) {
  if (!value || typeof value !== "object") return null
  const match = campaigns.find(item => CAMPAIGN_KEYS.every(key => item[key] === value[key]))
  return match ? Object.fromEntries(CAMPAIGN_KEYS.map(key => [key, match[key]])) : null
}

export function ctaProperties(id, config = catalog) {
  const item = Object.hasOwn(config.ctas, id || "") ? config.ctas[id] : null
  return item ? { cta_id: id, placement: item.placement, offer: item.offer } :
    { cta_id: "unannotated", placement: "unspecified", offer: "unspecified" }
}

function cleanPath(value, fallback) {
  return typeof value === "string" && value.startsWith("/") && !/[?#\s]/.test(value) ? value : fallback
}

function externalHost(referrer, origin) {
  try {
    const ref = new URL(referrer)
    return ref.origin === origin || ["teloslabs.co", "www.teloslabs.co"].includes(ref.hostname) ? "" : ref.hostname
  } catch { return "" }
}

export function buildAttribution(url, referrer, storage, config) {
  let stored
  try {
    storage?.removeItem("telos_landing") // Retire the old query-bearing landing value.
    stored = JSON.parse(storage?.getItem(STORAGE_KEY) || "null")
  } catch { /* Storage is optional, including on privacy-restricted browsers. */ }
  if (stored?.version !== 1) stored = null
  const campaign = approvedCampaign(Object.fromEntries(CAMPAIGN_KEYS.map(key =>
    [key, url.searchParams.get(`utm_${key}`)])), config.campaigns)
  const first = approvedCampaign(stored?.first, config.campaigns) || campaign
  const latest = campaign || approvedCampaign(stored?.latest, config.campaigns)
  const referringHost = typeof stored?.referring_host === "string" &&
    /^[a-z0-9.-]+$/i.test(stored.referring_host) ? stored.referring_host : externalHost(referrer, url.origin)
  const record = {
    version: 1, landing_path: cleanPath(stored?.landing_path, url.pathname),
    referring_host: referringHost, first, latest,
  }
  try { storage?.setItem(STORAGE_KEY, JSON.stringify(record)) } catch { /* Best effort. */ }
  const cta = ctaProperties(url.searchParams.get("cta"), config)
  const offer = cta.cta_id !== "unannotated" ? cta.offer :
    (config.offers.includes(url.searchParams.get("offer")) ? url.searchParams.get("offer") : "unspecified")
  const result = {
    landing_page: record.landing_path, referring_host: referringHost,
    acquisition_source: latest?.source || referringHost || "direct",
    cta_origin: cta.cta_id === "unannotated" ? "unspecified" : cta.cta_id, offer,
  }
  for (const [prefix, values] of [["first", first], ["latest", latest]]) {
    if (values) for (const key of CAMPAIGN_KEYS) result[`${prefix}_utm_${key}`] = values[key]
  }
  return result
}

export function setupAttribution(doc = document, win = window) {
  try {
    const data = JSON.parse(doc.getElementById("marketing-catalog")?.textContent || "{}")
    catalog = { offers: data.offers || [], ctas: data.ctas || {}, campaigns: data.campaigns || [] }
    let storage
    try { storage = win.sessionStorage } catch { /* Current-page attribution still works. */ }
    context = buildAttribution(new URL(win.location.href), doc.referrer, storage, catalog)
  } catch { context = { offer: "unspecified", cta_origin: "unspecified" } }
}

export function marketingContext() { return { ...context } }
